import { useMutation, useQueryClient } from "@tanstack/react-query";

import { UpdateRedeterminationType } from "@/domain/redeterminations";

import { RedeterminationsApi } from "../api/redeterminationsApi";
import { RedeterminationsQueryKeys } from "../queries/redeterminationsQueries";

export const useUpdateRedeterminationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      redeterminationData,
    }: {
      id: string;
      redeterminationData: UpdateRedeterminationType;
    }) => RedeterminationsApi.updateRedetermination(id, redeterminationData),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: RedeterminationsQueryKeys.all,
      });
    },
  });
};
